import * as React from "react";

import { CaseLawDocumentStatus, CourtCaseType } from "../../common/Constants";
import {
  Typography,
  Button,
  Col,
  Row,
  Form,
  Checkbox,
  Input,
  Select,
  Descriptions,
  List,
  Space,
  Card,
  Popconfirm
} from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import CaseLawDocumentAttachmentTable from "./CaseLawDocumentAttachmentTable";
import TextArea from "antd/lib/input/TextArea";
import { ICourtCase } from "../../model/CourtCase";
import { IOrganisation } from "../../../organisations/model/Organisation";
import SelectInput from "../../../core/ui/components/SelectInput";
import CourtCaseGrid from "./CourtCaseGrid";
import moment from "moment";
import { TCaseLawDocumentPresentationModel } from "../../presenter/model/CaseLawDocumentPresentationModel";
import SearchInput from "./SearchInput";
import Link from "../../../core/ui/components/Link";
import TranslationTextAreaField from "../../../core/ui/components/TranslationTextAreaField";
import { IStore } from "../../../core/model/runtime/state/Store";
import { TOrganisationIndexGroupPresentationModel } from "../../../organisations/presenter/model/OrganisationIndexGroupPresentationModel";
import { IDocumentTypeIndexCategory } from "../../../documentTypes/model/DocumentTypeIndexCategory";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import FormSection from "../../../core/ui/components/FormSection";
import CaseLawDocumentCourtCaseDescription from "./CaseLawDocumentCourtCaseDescription";
import DateTimePicker from "../../../core/ui/components/DateTimePicker";
import { DateFormats } from "../../../core/common/Constants";
import { ICourtCaseConnectionType } from "../../model/CourtCaseConnectionType";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { IIndexTypeAttribute } from "../../../indexTypes/model/IndexTypeAttribute";
import { IIndexAttributeData } from "../../../indexTypes/model/IndexAttributeData";
import IndexAttributeDataForm from "./IndexAttributeDataForm";
import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";

const FormFields = {
  ID: "id",
  SEARCH_ID: "searchId",
  NOTES: "notes",
  SUMMARY: "summary",
  STATUS: "status",
  CASE_LAW_DOCUMENT_TYPE_CODE: "documentTypeId",
  DOCUMENT_TYPE_ID: "documentTypeId",
  COURT_CASE: "courtCaseList",
  ORGANISATION_ID: "organisationId",
  VALID: "valid",
  PRIMARY_COURT_CASE: "primaryCourtCase",
  DATE: "caseLawDocDate",
  ORGANISATION_INDEX_ID: "organisationIndexId",
  ORGANISATION_INDEX_LIST: "organisationIndexList",
  PARENT_GROUP: "parentGroup",
  SECOND_GROUP: "secondGroup",
  INVALIDATE_PUBLISHED_CASE_LAW_DOCS: "invalidatePublishedCaseLawDocs",
  INVALIDATED_CASE_LAW_DOCUMENTS: "invalidatedCaseLawDocuments",
  CASE_LAW_DOCUMENT_ID: "caseLawDocumentId",
  INVALIDATION_REASON: "invalidationReason"
};

const CaseLawDocumentForm = ({
  translate,
  caseLawDocument,
  attachmentTypes,
  attachmentContentTypes,
  caseLawDocumentAttachments,
  createAttachment,
  setFileValue,
  uploadedFile,
  updateAttachment,
  removeAttachment,
  organisationIndexes,
  selectedCourtCases,
  removeConnectedCourtCase,
  createConnectedCourtCase,
  connectedCourtCasesList,
  selectedIndex: selectedIndexes,
  onSubmit,
  showCaseLawDocumentDetails,
  attachmentLoader,
  parentGroupList,
  secondGroupList,
  selectedParentGroupIdList,
  selectedSecondGroupIdList,
  setParentGroupId,
  setSecondGroupId,
  onSearch,
  publishedCaseLawDocuments,
  invalidatePublishedCaseLawDocsVisible,
  invalidatedCaseLawDocuments,
  store,
  selectedOrganisationId,
  courtCaseConnectionTypeList,
  updateCourtCaseSelection,
  courtCaseSelectionResult,
  createCourtCasePopupVisible,
  createCourtCaseModalVisible,
  showCreateCourtCasePopupVisible,
  showCreateCourtCaseModalVisible,
  createCourtCase,
  nonExistantCourtCaseNumber,
  createCourtCaseAttachment,
  uploadedCourtCaseAttachment,
  findCourtCaseDetails,
  anonimisedUploadedFile,
  setAnonymisedFileValue,
  canEdit,
  courtCaseTypes,
  decisionTypes,
  indexTypeAttributes,
  setAttributesData,
  indexAttributeDataList,
  closeIndexDataModal,
  openIndexDataModal,
  indexDataModalVisible,
  saveAttributeData,
  selectedIndexForAttribute,
  onSelectConnectedCourtCaseDecision,
  selectedCaseDecision
}: {
  caseLawDocument: TCaseLawDocumentPresentationModel;
  attachmentContentTypes;
  caseLawDocumentAttachments;
  createAttachment;
  setFileValue;
  uploadedFile: any;
  updateAttachment;
  removeAttachment;
  indexHierarchyList;
  publishCaseLawDocument;
  revertCaseLawDocumentStatus;
  showCaseLawDocumentDetails: any;
  translate: any;
  caseLawDocumentTypes: IDocumentType[];
  organisations: IOrganisation[];
  setOrganisationId: any;
  organisationIndexes: IDocumentTypeIndexCategory[];
  selectedCourtCases?: ICourtCase[];
  removeConnectedCourtCase: any;
  createConnectedCourtCase: any;
  connectedCourtCasesList: ICourtCase[];
  selectedIndex?: any;
  organisationCaseLawDocumentTypeId?: number;
  nonAnonymisedAttachmentsCount?: number;
  onSubmit: any;
  attachmentTypes;
  attachmentLoader;
  parentGroupList: TOrganisationIndexGroupPresentationModel[][];
  secondGroupList: TOrganisationIndexGroupPresentationModel[][];
  selectedParentGroupIdList: number[];
  selectedSecondGroupIdList: number[];
  setParentGroupId: (selectedParentGroupId: number, index: number) => void;
  setSecondGroupId: (selectedSecondGroupId: number, index: number) => void;
  archiveCaseLawDocument?: any;
  onSearch: (value: string) => void;
  setInvalidatePublishedCaseLawDocuments: (value: boolean) => void;
  publishedCaseLawDocuments: any;
  invalidatePublishedCaseLawDocsVisible: boolean;
  invalidatedCaseLawDocuments: TCaseLawDocumentPresentationModel[];
  store: IStore;
  selectedOrganisationId?: number;
  courtCaseConnectionTypeList: ICourtCaseConnectionType[];
  updateCourtCaseSelection;
  courtCaseSelectionResult;
  createCourtCasePopupVisible;
  createCourtCaseModalVisible;
  showCreateCourtCasePopupVisible;
  showCreateCourtCaseModalVisible;
  createCourtCase;
  nonExistantCourtCaseNumber;
  createCourtCaseAttachment;
  uploadedCourtCaseAttachment;
  findCourtCaseDetails;
  anonimisedUploadedFile;
  setAnonymisedFileValue;
  canEdit: any;
  courtCaseTypes: IGenericCodebookItem[];
  decisionTypes: IGenericCodebookItem[];
  indexTypeAttributes?: IIndexTypeAttribute[];
  setAttributesData?: any;
  indexAttributeDataList?: IIndexAttributeData[];
  closeIndexDataModal: any;
  openIndexDataModal: any;
  indexDataModalVisible: boolean;
  saveAttributeData: any;
  selectedIndexForAttribute: any;
  onSelectConnectedCourtCaseDecision(
    courtCase: ICourtCase,
    value: ICaseDecision
  );
  selectedCaseDecision?: ICaseDecision;
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  function onChangeParentGroup(value, index) {
    setParentGroupId(value, index);
    form.setFields([
      {
        name: ["secondGroup", index],
        value: undefined
      },
      {
        name: ["organisationIndexList", index],
        value: undefined
      }
    ]);
    setSecondGroupId(NaN, index);
  }

  function onChangeSecondGroup(value, index) {
    setSecondGroupId(value, index);
    if (selectedParentGroupIdList.length == 0) {
      setParentGroupId(
        secondGroupList[index].find((elem) => elem.id === value)?.parentId ??
          NaN,
        index
      );
      form.setFields([
        {
          name: ["parentGroup", index],
          value:
            secondGroupList[index].find((elem) => elem.id === value)
              ?.parentId ?? NaN
        }
      ]);
      form.setFieldsValue({
        organisationIndexList: undefined
      });
    }
  }
  function filterIndexData(list, index) {
    let newList = list;
    if (selectedParentGroupIdList[index]) {
      newList = list.filter(
        (item) =>
          item.groups.findIndex(
            (element) => element.id === selectedParentGroupIdList[index]
          ) !== -1
      );
    }
    if (selectedSecondGroupIdList[index]) {
      newList = newList.filter(
        (item) =>
          item.groups.findIndex(
            (element) => element.id === selectedSecondGroupIdList[index]
          ) !== -1
      );
    }

    return newList;
  }
  function filterSecondGroupValues(index) {
    const selectedParentGroupId = selectedParentGroupIdList[index];
    let newList = selectedParentGroupId
      ? secondGroupList[index].filter(
          (elem) => elem.parentId === selectedParentGroupId
        )
      : secondGroupList[index];

    return newList;
  }
  function findParent(group, groupList, data) {
    if (group?.parentId) {
      let g = groupList.find((g) => g.id === group?.parentId);
      if (g) {
        data = data + ` 🡐 ${g?.name}`;
        return findParent(g, groupList, data);
      }
    } else if (group?.organisationIndexCategory) {
      data = data + ` 🡐 ${group?.organisationIndexCategory?.name}`;
    }
    return data;
  }

  function renderOptions(list) {
    return list.map((index) => {
      let data = index.name;
      if (index.groups) {
        let firstGroup = index.groups.find(
          (g) => g.id === index.organisationGroupId
        );
        data = `${index?.name} 🡐 ${firstGroup?.name}`;
        data = findParent(firstGroup, index.groups, data);
      }
      return (
        <Option key={index.id} value={index.id} title={data} label={data}>
          {data}
        </Option>
      );
    });
  }

  function renderPrimaryCase() {
    let primaryCase = selectedCourtCases?.find(
      (item) => item.type === CourtCaseType.PRIMARY
    );

    return (
      primaryCase && (
        <CaseLawDocumentCourtCaseDescription
          courtCase={primaryCase}
          translate={translate}
        />
      )
    );
  }

  caseLawDocument &&
    form.setFieldsValue({
      documentTypeId: caseLawDocument.documentTypeId,
      organisationId: caseLawDocument.organisationId,
      summary: caseLawDocument.summaryTranslation ?? caseLawDocument.summary,
      organisationIndexId: selectedIndexes?.id,
      id: caseLawDocument.id,
      searchId: caseLawDocument.searchId,
      notes: caseLawDocument.notes,
      valid: caseLawDocument.valid,
      status: caseLawDocument.status,
      primaryCourtCase: selectedCourtCases?.find(
        (item) => item.type === CourtCaseType.PRIMARY
      )?.courtCaseNumber,
      summaryTranslations:
        caseLawDocument?.summaryTranslations?.length > 0
          ? caseLawDocument.summaryTranslations
          : [
              {
                summaryTranslation: caseLawDocument.summary,
                languageId: store.getState<any>().selectedLanguage.id
              }
            ],
      caseLawDocDate: caseLawDocument.caseLawDocDate
        ? moment(caseLawDocument.caseLawDocDate)
        : null,
      parentGroup: selectedParentGroupIdList
    });
  return (
    <Form layout={"vertical"} form={form}>
      <Row align="middle" justify="center">
        <Col xl={20} lg={24} md={24} sm={24} xs={24}>
          <Card bordered={false}>
            <Form.Item
              name={FormFields.ID}
              initialValue={caseLawDocument?.id}
              style={{ display: "none" }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={FormFields.SEARCH_ID}
              initialValue={caseLawDocument?.searchId}
              style={{ display: "none" }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={FormFields.ORGANISATION_ID}
              initialValue={caseLawDocument?.organisationId}
              style={{ display: "none" }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={FormFields.DOCUMENT_TYPE_ID}
              initialValue={caseLawDocument?.documentTypeId}
              style={{ display: "none" }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={translate("editors.case_law_documents.date")}
              name={FormFields.DATE}
              style={{ display: "none" }}
              initialValue={
                caseLawDocument.caseLawDocDate
                  ? moment(caseLawDocument.caseLawDocDate)
                  : null
              }
              className={"mb-sm-0"}
            >
              <DateTimePicker
                placeholder={translate("date_picker.placeholder")}
                format={DateFormats.DATE}
                showToday={true}
                className={"input-date-wrapper"}
                translate={translate}
              />
            </Form.Item>
            <Form.Item
              label={translate("editors.case_law_documents.valid")}
              name={FormFields.VALID}
              valuePropName={"checked"}
              initialValue={caseLawDocument.valid ?? true}
              style={{ display: "none" }}
            >
              <Checkbox />
            </Form.Item>
            <Form.Item
              style={{ display: "none" }}
              label={translate("editors.case_law_documents.status")}
              name={FormFields.STATUS}
              initialValue={
                caseLawDocument?.status ?? CaseLawDocumentStatus.IN_PROGRESS
              }
              className={"mb-0"}
              rules={[
                {
                  required: true,
                  message: translate(
                    "editors.case_law_documents.required_messages",
                    {
                      field: translate("editors.case_law_documents.status")
                    }
                  )
                }
              ]}
            >
              <Input />
            </Form.Item>
            <Space direction="vertical" style={{ width: "100%" }}>
              <FormSection
                title={translate("editors.case_law_documents.basic_data")}
                subtitle={translate("editors.case_law_documents.basic_data")}
              >
                <Row gutter={16} style={{ marginBottom: 10, marginTop: 10 }}>
                  <Col xs={24} sm={24}>
                    <TranslationTextAreaField
                      translate={translate}
                      organisationId={selectedOrganisationId}
                      translationObjectIdFieldName={"caseLawDocumentId"}
                      store={store}
                      form={form}
                      rowData={caseLawDocument}
                      label={translate("editors.case_law_documents.summary")}
                    />
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginBottom: 10, marginTop: 10 }}>
                  <Col xs={24} sm={24}>
                    <Form.Item
                      initialValue={caseLawDocument?.notes}
                      label={translate("editors.case_law_documents.notes")}
                      name={FormFields.NOTES}
                    >
                      <TextArea />
                    </Form.Item>
                  </Col>
                </Row>
              </FormSection>
              <FormSection
                title=""
                subtitle={translate(
                  "editors.case_law_documents.primary_court_case"
                )}
              >
                <Row gutter={16}>
                  <Col xs={24} sm={24}>
                    {renderPrimaryCase()}
                  </Col>
                </Row>
              </FormSection>
              {organisationIndexes?.length > 0 && (
                <FormSection
                  title={translate("editors.case_law_documents.classification")}
                  subtitle={translate(
                    "editors.case_law_documents.sections.index_subtitle"
                  )}
                >
                  {organisationIndexes.map((item, index) => {
                    return (
                      <>
                        <Row
                          style={
                            organisationIndexes.length === 0
                              ? { display: "none" }
                              : {
                                  marginTop: 10,
                                  alignItems: "center"
                                }
                          }
                        >
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            style={{
                              marginTop: 20,
                              alignItems: "center"
                            }}
                          ></Col>

                          <Col
                            span={7}
                            style={{
                              display: "none",
                              marginTop: 20,
                              alignItems: "center"
                            }}
                          >
                            <Form.Item
                              label={translate(
                                "editors.case_law_documents.second_group"
                              )}
                              className={"mb-0"}
                              style={{
                                width: "100%",
                                marginRight: 10
                              }}
                              initialValue={selectedSecondGroupIdList[index]}
                              name={[FormFields.SECOND_GROUP, index]}
                              shouldUpdate
                            >
                              <SelectInput
                                allowClear
                                placeholder={translate(
                                  "editors.case_law_documents.select_second_group"
                                )}
                                showSearch={true}
                                notFoundContent={translate("search.no_data")}
                                selectOptionKey={"id"}
                                selectOptionValue={"name"}
                                selectOptions={filterSecondGroupValues(index)}
                                onChange={(value) =>
                                  onChangeSecondGroup(value, index)
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            style={{
                              marginTop: 20,
                              alignItems: "center"
                            }}
                          >
                            <Form.Item
                              name={[FormFields.ORGANISATION_INDEX_LIST, index]}
                              className={"mb-0"}
                              shouldUpdate
                              label={translate(
                                "editors.case_decisions.index_data"
                              )}
                              rules={[
                                {
                                  required: item.required,
                                  message: translate(
                                    "editors.case_decisions.required_messages",
                                    {
                                      field: translate(
                                        "editors.case_decisions.case_decision_type"
                                      )
                                    }
                                  )
                                },
                                {
                                  validator: (rule, value, callback) => {
                                    if (value && item.maxLength) {
                                      if (value.length > item.maxLength) {
                                        callback(
                                          `${translate(
                                            "editors.case_law_documents.index.max_length"
                                          )} ${item.maxLength}`
                                        );
                                      } else if (
                                        value.length <= item.maxLength
                                      ) {
                                        callback();
                                      }
                                    } else {
                                      callback();
                                    }

                                    return;
                                  }
                                }
                              ]}
                              initialValue={selectedIndexes[index].map(
                                (item) => item.id
                              )}
                            >
                              <Select
                                placeholder={translate(
                                  "editors.case_law_documents.select_index_data"
                                )}
                                mode="multiple"
                                showSearch
                                optionFilterProp="children"
                                className={"png-tagbox"}
                                onChange={(idList: []) => {
                                  openIndexDataModal(
                                    item.organisationIndexList?.filter(
                                      (i) => i.id === idList[idList.length - 1]
                                    )[0],
                                    idList,
                                    index
                                  );
                                }}
                              >
                                {renderOptions(
                                  filterIndexData(
                                    item.organisationIndexList,
                                    index
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    );
                  })}
                </FormSection>
              )}

              <FormSection
                title={translate(
                  "editors.case_law_documents.connected_court_cases"
                )}
                subtitle={translate(
                  "editors.case_law_documents.connected_court_cases"
                )}
              >
                <Col xs={24} sm={24}>
                  <Popconfirm
                    title={translate(
                      "editors.court_cases.non_existing_court_case_popconfirm_message"
                    )}
                    visible={createCourtCasePopupVisible}
                    onCancel={() => showCreateCourtCasePopupVisible(false)}
                    onConfirm={() => {
                      showCreateCourtCaseModalVisible(true);
                      showCreateCourtCasePopupVisible(false);
                    }}
                  />
                  <CourtCaseGrid
                    translate={translate}
                    courtCases={connectedCourtCasesList || []}
                    createConnectedCourtCase={createConnectedCourtCase}
                    removeCourtCase={removeConnectedCourtCase}
                    courtCaseConnectionTypeList={courtCaseConnectionTypeList}
                    updateCourtCaseSelection={updateCourtCaseSelection}
                    courtCaseSelectionResult={courtCaseSelectionResult}
                    createCourtCasePopupVisible={createCourtCasePopupVisible}
                    createCourtCaseModalVisible={createCourtCaseModalVisible}
                    showCreateCourtCasePopupVisible={
                      showCreateCourtCasePopupVisible
                    }
                    showCreateCourtCaseModalVisible={
                      showCreateCourtCaseModalVisible
                    }
                    findCourtCase={findCourtCaseDetails}
                    createCourtCase={createCourtCase}
                    nonExistantCourtCaseNumber={nonExistantCourtCaseNumber}
                    createCourtCaseAttachment={createCourtCaseAttachment}
                    uploadedCourtCaseAttachment={uploadedCourtCaseAttachment}
                    courtCaseTypes={courtCaseTypes}
                    decisionTypes={decisionTypes}
                    selectedCaseDecision={selectedCaseDecision}
                    onSelectCaseDecision={onSelectConnectedCourtCaseDecision}
                  />
                </Col>
              </FormSection>
              <FormSection
                title={translate(
                  "editors.case_law_documents.invalidated_case_law_docs"
                )}
                subtitle={translate(
                  "editors.case_law_documents.invalidated_case_law_docs"
                )}
                style={
                  invalidatePublishedCaseLawDocsVisible
                    ? {}
                    : { display: "none" }
                }
              >
                <List
                  size="large"
                  locale={{
                    emptyText: translate("data_grid.empty_text")
                  }}
                  dataSource={invalidatedCaseLawDocuments}
                  renderItem={(item) => (
                    <List.Item
                      style={{ cursor: "pointer" }}
                      className={"card-list-item"}
                    >
                      <Col>
                        <Link
                          block
                          type="text"
                          onClick={() => showCaseLawDocumentDetails(item.id)}
                          children={
                            <Col>
                              <Typography.Paragraph
                                ellipsis={{ rows: 3 }}
                                strong
                              >
                                {item.summary}
                              </Typography.Paragraph>
                            </Col>
                          }
                        />
                      </Col>
                      <Row className={"card-list-item-decriptions"}>
                        <Col>
                          <Descriptions size={"small"}>
                            <Descriptions.Item
                              style={{ width: "40%" }}
                              label={
                                <strong>
                                  {translate(
                                    "editors.case_law_documents.organisation_name"
                                  )}
                                </strong>
                              }
                            >
                              {item.organisationName}
                            </Descriptions.Item>

                            <Descriptions.Item
                              style={{ width: "20%" }}
                              label={
                                <strong>
                                  {translate("editors.case_law_documents.date")}
                                </strong>
                              }
                            >
                              {item.formattedDate}
                            </Descriptions.Item>
                          </Descriptions>
                        </Col>
                      </Row>
                    </List.Item>
                  )}
                />
                <Form.Item
                  label={translate(
                    "editors.case_law_documents.case_law_documents_to_be_invalidated"
                  )}
                  className={"mb-0"}
                  name={FormFields.INVALIDATED_CASE_LAW_DOCUMENTS}
                >
                  <SearchInput
                    mode={"multiple"}
                    data={publishedCaseLawDocuments}
                    placeholder={translate(
                      "editors.case_law_documents.search_case_law_documents"
                    )}
                    translate={translate}
                    searchAndUpdateData={onSearch}
                    onChange={(value) =>
                      form.setFieldsValue({
                        invalidatedCaseLawDocuments: value
                      })
                    }
                  ></SearchInput>
                </Form.Item>
                <Form.Item
                  className={"mb-0"}
                  label={translate(
                    "editors.case_law_documents.invalidation_reason"
                  )}
                  name={FormFields.INVALIDATION_REASON}
                >
                  <TextArea />
                </Form.Item>
              </FormSection>
            </Space>
          </Card>
        </Col>
      </Row>
      <IndexAttributeDataForm
        closeIndexDataModal={closeIndexDataModal}
        indexAttributeDataList={indexAttributeDataList}
        indexDataModalVisible={indexDataModalVisible}
        indexTypeAttributes={indexTypeAttributes}
        saveAttributeData={saveAttributeData}
        form={form}
        setAttributesData={setAttributesData}
        translate={translate}
        selectedIndexForAttribute={selectedIndexForAttribute}
      />
      <Row justify="center">
        <Col
          lg={20}
          md={24}
          sm={24}
          xs={24}
          style={{ textAlign: "right", paddingTop: 20 }}
        >
          <Button
            value=""
            type="link"
            danger
            onClick={() => {
              form.resetFields();
              showCaseLawDocumentDetails(caseLawDocument.id);
            }}
          >
            <CloseOutlined /> {translate("data_grid.modal.actions.cancel")}
          </Button>
          <Button
            value=""
            type={"primary"}
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  onSubmit(values);
                })
                .catch((info) => {});
            }}
          >
            <CheckOutlined /> {translate("data_grid.modal.actions.save")}
          </Button>
        </Col>
      </Row>
      <Row align="middle" justify="center" style={{ marginTop: 80 }}>
        <Col xl={20} lg={24} md={24} sm={24} xs={24}>
          <Card>
            <FormSection
              title={translate("editors.case_law_documents.attachments")}
              subtitle={translate("editors.case_law_documents.attachments")}
            >
              <CaseLawDocumentAttachmentTable
                caseLawDocument={caseLawDocument}
                translate={translate}
                attachmentTypes={attachmentTypes}
                attachmentContentTypes={attachmentContentTypes}
                caseLawDocumentAttachments={caseLawDocumentAttachments}
                createAttachment={createAttachment}
                setFileValue={setFileValue}
                uploadedFile={uploadedFile}
                updateAttachment={updateAttachment}
                removeAttachment={removeAttachment}
                referenceLoader={attachmentLoader}
                editable={true}
                anonimisedUploadedFile={anonimisedUploadedFile}
                setAnonymisedFileValue={setAnonymisedFileValue}
                canDownload={canEdit}
              />
            </FormSection>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};
export default CaseLawDocumentForm;
